import { useMemo } from "react";
import { GlobalStore } from "../store/global/GlobalStore";

export const useSelectedGuildRole = () => {
  const roles = GlobalStore.useState(s => s.userRoles);
  const selectedRole = useMemo(() => {
    return roles.find(role => role.access);
  }, [roles]);

  return selectedRole;
};
